import axios from 'axios';

// Same-origin, deliberately. Every auth call goes to whichever server served
// the page: village-dev signs into village-dev, the live site into the live
// site, a local copy into itself.
//
// This used to read a build-time setting (REACT_APP_API_URL), and the live
// address got baked into the one build that shipped everywhere. The result was
// that a password typed into the sign-in box on the test site was posted to
// production, and the test site could not be signed into at all — see CV-817
// and CV-819.
//
// Do not reintroduce the setting and do not point this at a host.
// scripts/verify-client-bundle-origin.js fails the build if you do.
axios.defaults.baseURL = '/';

export default axios;
